module.exports = "/images/down-arrow.svg?3b875306b01d38e1a5199d5cf48173b8";